
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.4029 20.3502C18.5335 19.1031 20.818 16.1864 21.1565 12.7H17.3905C17.2677 15.7851 16.5189 18.5104 15.4029 20.3502ZM12 22.8C18.0751 22.8 23 17.8751 23 11.8C23 5.72486 18.0751 0.799988 12 0.799988C5.92487 0.799988 1 5.72486 1 11.8C1 17.8751 5.92487 22.8 12 22.8ZM8.5971 3.24982C5.46646 4.49688 3.18196 7.41356 2.84346 10.9H6.60952C6.73235 7.81489 7.48106 5.08953 8.5971 3.24982ZM8.41105 10.9C8.51688 8.45424 9.04784 6.32763 9.79105 4.81601C10.6813 3.00528 11.5716 2.59999 12 2.59999C12.4284 2.59999 13.3187 3.00528 14.209 4.81601C14.9522 6.32763 15.4831 8.45424 15.589 10.9H8.41105ZM8.41105 12.7C8.51689 15.1457 9.04784 17.2723 9.79105 18.784C10.6813 20.5947 11.5716 21 12 21C12.4284 21 13.3187 20.5947 14.209 18.784C14.9522 17.2723 15.4831 15.1457 15.589 12.7H8.41105ZM6.60952 12.7C6.73235 15.7851 7.48107 18.5104 8.5971 20.3502C5.46646 19.1031 3.18196 16.1864 2.84346 12.7H6.60952ZM17.3905 10.9C17.2677 7.8149 16.5189 5.08953 15.4029 3.24982C18.5335 4.49688 20.818 7.41356 21.1565 10.9H17.3905Z","fill":"#16171F"}})])
          )
        }
      }
    